var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SvgIcon',_vm._g({style:(_vm.rootStyle),attrs:{"svg":require('!svg-inline-loader?classPrefix!@mdi/svg/svg/volume-high.svg'),"size":_vm.size,"button":_vm.button}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }